<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Default Contribution Percentages</h1>
    <p>Where new employees are added to the occupational pension scheme, default contributions can be applied.</p>
    <p>Please provide the default contribution percentages for your scheme.</p>
  </div>
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
        <label>Employee Contribution (%)</label>
            <input 
              type="number" 
              id="employeeContribution" 
              name="employeeContribution" 
              placeholder="" 
              v-model="formData.employeeContribution" 
              required
              min="0"
              max="100"
              maxlength="3"
            />
        <label>Employer Contribution (%)</label>
            <input 
              type="number" 
              id="employerContribution" 
              name="employerContribution" 
              placeholder="" 
              v-model="formData.employerContribution" 
              required
              min="0"
              max="100"
              maxlength="3"
            />

      </form>
    </div>  


</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref(null)
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {


  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "CompanyPension",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }



  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>